import { FormatterService } from "@/domain/services";
import { formatters } from "../utils/formatters";

export class CardNumberFormatter implements FormatterService {
  searchValue = formatters.card_number.searchValue;
  replaceValue = formatters.card_number.replaceValue;

  format(value: string): string {
    return value.replace(this.searchValue, this.replaceValue).trim();
  }
}
